import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  IconButton,
  Link,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { palette } from '../../../../theme';
import Links from '../../../../constants/links';

import { BrowserDesktopIcon } from '../../../common/Icons';
import { DESIGN_APP_SUPPORTED_BROWSERS } from '../../../../constants';

const RequiredBrowserModal = ({ open, handleClose }) => (
  <Dialog open={open} onClose={handleClose}>
    <Box display="flex" justifyContent="flex-end" alignItems="flex-end">
      <IconButton onClick={handleClose} sx={{ margin: '5px 5px 0 0' }}>
        <Close sx={{ fontSize: '1.2rem', color: palette.primary.main }} />
      </IconButton>
    </Box>
    <DialogContent style={{ maxWidth: 280, padding: '0 34px 30px' }}>
      <Box textAlign="center">
        <BrowserDesktopIcon sx={{ height: '65%', width: '65%' }} />
        <DialogContentText
          textAlign="left"
          sx={{ fontSize: '0.9rem', margin: '0.5em auto 1em', color: palette.primary.main }}
        >
          Showit is made for Google Chrome on desktop. You can also try out the beta version for
          Safari {DESIGN_APP_SUPPORTED_BROWSERS.safari.minVersion}.{' '}
          <Link
            target="_blank"
            href={Links.SAFARI_BETA_LEARN_MORE}
            title="Learn More"
            underline="always"
            style={{ cursor: 'pointer' }}
          >
            Learn more
          </Link>
        </DialogContentText>
        <Button
          title="Close Notice"
          type="submit"
          variant="contained"
          onClick={handleClose}
          fullWidth
        >
          Close
        </Button>
      </Box>
    </DialogContent>
  </Dialog>
);

RequiredBrowserModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default RequiredBrowserModal;
